import { createContext } from 'react';

type ReactRoutesContextType = {
  isReactAppMounted: boolean;
};

const ReactRoutesContext = createContext<ReactRoutesContextType | undefined>(
  undefined,
);

export default ReactRoutesContext;
